import { useEffect, useRef, useState } from "react";
import { Chart } from "react-google-charts";

export default function ClientPiechart() {
  const containerRef = useRef(null);
  const [chartKey, setChartKey] = useState(0);
  const [range, setRange] = useState("weekly");
  const [isDark, setIsDark] = useState(false);

  /* ---------- Resize Fix ---------- */
  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver(() => {
      setChartKey((prev) => prev + 1);
    });

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  /* ---------- Detect Dark Mode ---------- */
  useEffect(() => {
    const checkTheme = () => {
      setIsDark(document.documentElement.classList.contains("dark"));
    };

    checkTheme();

    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  /* ---------- DATA ---------- */

  const weeklyData = [
    ["Company", "Campaigns"],
    ["SecureHorizon", 6],
    ["CyberSentinel", 4],
    ["GuardianVault", 3],
    ["HeadDefense", 18],
    ["TrustLock Systems", 5],
  ];

  const monthlyData = [
    ["Company", "Campaigns"],
    ["SecureHorizon", 12],
    ["CyberSentinel", 8],
    ["GuardianVault", 6],
    ["HeadDefense", 64],
    ["TrustLock Systems", 10],
  ];

  const data = range === "weekly" ? weeklyData : monthlyData;

  /* ---------- OPTIONS ---------- */

  const options = {
    backgroundColor: "transparent",
    pieHole: 0.4,
    is3D: true,
    pieStartAngle: 100,
    sliceVisibilityThreshold: 0.02,

    legend: {
      position: "bottom",
      alignment: "center",
      textStyle: {
        fontSize: 11,
        fontName: "Poppins",
        color: isDark ? "#cbd5f5" : "#475569",
      },
    },

    chartArea: {
      width: "75%",
      top: 20,
      bottom: 40,
    },

    colors: ["#1e88e5", "#fb8c00", "#43a047", "#8e24aa", "#f44336"],
  };

  return (
    <div
      ref={containerRef}
      className="
        w-full h-[400px]
        p-4
        rounded-xl
        bg-white dark:bg-slate-800
        shadow
        border border-slate-200 dark:border-slate-700
        flex flex-col
      "
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-2">
        <h6 className="m-0 text-base font-medium text-slate-800 dark:text-slate-200">
          Risk Level by User
        </h6>

        <select
          value={range}
          onChange={(e) => setRange(e.target.value)}
          className="
            text-sm px-2 py-1 rounded
            border border-slate-300 dark:border-slate-600
            bg-white dark:bg-slate-900
            text-slate-900 dark:text-slate-200
            focus:outline-none
          "
        >
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>
      </div>

      {/* Chart */}
      <div className="flex-1">
        <Chart
          key={chartKey}
          chartType="PieChart"
          data={data}
          options={options}
          height="300px"
        />
      </div>
    </div>
  );
}